import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ProgressLine',
    props: {
        width: { default: 10 },
        percentage: { default: 10 },
        color: { default: '#cdd0d4' },
        backgroundColor: { default: '#F2F2F2' }
    },
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle({
                    height: _ctx.width + 'px',
                    backgroundColor: _ctx.backgroundColor
                }),
                class: "progress"
            }, [
                _createElementVNode("div", {
                    style: _normalizeStyle({
                        width: _ctx.percentage > 100 ? 100 : _ctx.percentage + '%',
                        background: _ctx.color
                    }),
                    class: "progress__fill"
                }, null, 4)
            ], 4));
        };
    }
});
